import { render } from "./LivePageRoot.vue?vue&type=template&id=6132cc4e"
import script from "./LivePageRoot.vue?vue&type=script&lang=js"
export * from "./LivePageRoot.vue?vue&type=script&lang=js"

import "./LivePageRoot.vue?vue&type=style&index=0&id=6132cc4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/LivePageRoot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6132cc4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6132cc4e', __exports__)) {
    api.reload('6132cc4e', __exports__)
  }
  
  module.hot.accept("./LivePageRoot.vue?vue&type=template&id=6132cc4e", () => {
    api.rerender('6132cc4e', render)
  })

}


export default __exports__